export default "__VITE_ASSET__4JVSnMRx__"